import i18n from "@config/i18n";
import { ClassroomBookingStatusEnum } from "@models/ISchema";

enum StatusIcons {
  check = "circle-check",
  clock = "clock",
  close = "circle-cross",
}

enum StatusClassName {
  check = "iconStatusBooking__check",
  clock = "iconStatusBooking__clock",
  close = "iconStatusBooking__rejected",
}

enum ClassName {
  check = "iconStatusBooking--check",
  clock = "iconStatusBooking--clock",
  close = "iconStatusBooking--rejected",
}

const statusIcons = {
  pending: StatusIcons.clock,
  rejected: StatusIcons.close,
  confirmed: StatusIcons.check,
  cancelled: StatusIcons.close,
  expired: StatusIcons.close,
};

const statusClassName = {
  check: StatusClassName.check,
  clock: StatusClassName.clock,
  close: StatusClassName.close,
};

const getStatusI18nText = (code: string) => {
  const statuses = {
    pending: "booking.booking-details.resume.statuses.pending",
    rejected: "booking.booking-details.resume.statuses.rejected",
    confirmed: "booking.booking-details.resume.statuses.confirmed",
    cancelled: "booking.booking-details.resume.statuses.cancelled",
    expired: "booking.booking-details.resume.statuses.expired",
  };

  if (code in statuses) {
    return i18n.t(statuses[code]);
  }

  return "";
};

export const statusIcon = (code: ClassroomBookingStatusEnum | string) => {
  const icon: StatusIcons = statusIcons[code] || "check";
  return icon;
};

/**
 * @deprecated
 * replace for `iconClassName` (this implies a change on the scss's modified from `__` to `--`).
 */
export const statusIconClassName = (code: ClassroomBookingStatusEnum | string) => {
  const icon: StatusIcons = statusIcons[code] || "check";
  const className: StatusClassName = statusClassName[icon];
  return className;
};

/**
 * @deprecated
 * replace for `iconText`
 */
export const statusIconText = (code: ClassroomBookingStatusEnum | string) => {
  const text = getStatusI18nText(code) || "";
  return text;
};

export const iconText = (code: ClassroomBookingStatusEnum | string) => {
  const text = getStatusI18nText(code) || "";
  return text;
};

export const iconClassName = (code: ClassroomBookingStatusEnum | string) => {
  const icon: StatusIcons = statusIcons[code] || "check";
  const className = ClassName[icon];
  return className;
};

export const statusPillColor = (
  code: ClassroomBookingStatusEnum | string,
): {
  color: any;
  textColor: any;
  iconColor: any;
  iconFilled?: boolean;
} => {
  switch (code) {
    case ClassroomBookingStatusEnum.Confirmed:
      return {
        color: "success-opacity",
        textColor: "success-60",
        iconColor: "success-50",
        iconFilled: true,
      };
    case ClassroomBookingStatusEnum.Rejected:
    case ClassroomBookingStatusEnum.Cancelled:
    case ClassroomBookingStatusEnum.Expired:
      return {
        color: "error-opacity",
        textColor: "error-60",
        iconColor: "error-50",
        iconFilled: true,
      };
    default:
      return {
        color: "neutral-10",
        textColor: "neutral-70",
        iconColor: "neutral-70",
      };
  }
};
